import { all } from 'redux-saga/effects'
import usersSaga from '../reducers/users/usersSagas';
import uploadSaga from '../reducers/upload/uploadSagas';
function* rootSaga() {
    yield all([
        usersSaga(),
        uploadSaga(),
    ])
}
export default rootSaga;